define(['jquery', 'Cloud/Application/api'], function($, api) {
	return function(app, _) {
		const { captureMessage } = require('@sentry/browser');

		Object.assign(_, {
			openTab: function(url, name) {
				var tab = window.open(url, name || '');

				if ( tab ) {
					tab.focus();
				}

				return tab;
			}

			, openTabViaLink: function(url, downloadName) {
				//cloud-1674 Mobile Safari doesn't respect 'Content-Disposition: attachment' header
				//cloud-1722 Android stock browser doesn't start download
				// http://www.digiblog.de/2011/04/android-and-the-download-file-headers/

				var $el = $('<a />', {
					href: url
					, target: '_blank'
					, css: {
						position: "absolute"
						, visibility: "hidden"
					}
				})
					.appendTo('body')
				;

				if ( downloadName ) {//CLOUDWEB-4348
					$el.attr('download', downloadName);
				}

				var domElement = $el[0];
				var event;

				try {
					event = new (window.MouseEvent || window.Event)("click", {cancelable: false, bubbles: false});
				}
				catch(e) {
					event = window.document.createEvent("Events");
					event.initEvent( "click", false, false );
				}

				domElement.dispatchEvent(event);//we do not consider the case when event was canceled/prevented (dispatchEvent return false)

				$el.remove();
				event = domElement = $el = null;
			}

			, openPopup: function(url, name) {
				var popup = window.open(url, name, 'toolbar=0,status=0,menubar=0,location=0,directories=0,width=626,height=436');

				if ( popup ) {
					popup.focus();

				} else {
					captureMessage('POPUP BLOCKED', {
						arguments: {
							url: url
						}
					});

					api.emit('api-fail', 200, 'popup-open');
				}

				return popup;
			}
		})
	}
});
